// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"188":"f4df4751","594":"116a2096","864":"dbfcba9d","869":"b5823423"}[chunkId] + ".js";
};